module.exports = "<div class=\"order-billing-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <blnd-billing-component ng-model=\"vm.order\" edit-perm=\"'main.change_order'\"></blnd-billing-component>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/orders/templates/detail.billing.html
// module id = 641
// module chunks = 0